import { Button } from '@/components/ui/button';
import { KeyRound } from 'lucide-react';
import { useAuth } from 'hooks/useAuth';
import { useToast } from '@/hooks/use-toast';

export function TwoFactor() {
  const { toast } = useToast();
  const { user, createPasskeyCredentials, signinWithPasskey } = useAuth();

  if (!user) return null;

  const registerPasskey = async () => {
    await createPasskeyCredentials(user);
    toast({
      title: 'Passkey registered successfully',
      description: 'You can now sign in with this passkey instead of your password.',
    });
  };

  const testPasskey = async () => {
    await signinWithPasskey(user);
    toast({
      title: 'Your passkey is working correctly',
      description: `returned user email: ${user.email}`,
    });
  };

  return (
    <section className="bg-panel border-line rounded-panel border" data-tour="settings-account-passkeys">
      {/* Not "Two Factor Authentication". The signin screen offers "Continue with
          passkey" as a way in on its own, so a passkey replaces the password
          rather than adding to it. Calling it a second factor here would tell
          people they had added protection they have not. */}
      <div className="border-line flex items-center gap-2 border-b px-4 py-3">
        <KeyRound className="text-dim h-4 w-4" />
        <h2 className="text-foreground m-0 text-body font-medium">Passkeys</h2>
      </div>

      <div className="space-y-4 p-4">
        <div>
          <h3 className="text-foreground m-0 text-meta font-medium">Sign in without a password</h3>
          <p className="supporting m-0 mt-1">
            A passkey lets you sign in with your device instead of typing your password.
          </p>
          <p className="micro-label mt-2">
            {user.passkeyCount > 0
              ? `you currently have ${user.passkeyCount} passkey registered`
              : 'there are no passkeys registered for your account'}
          </p>
        </div>

        <div className="space-y-2">
          <Button className="h-10 w-full rounded-lg" onClick={registerPasskey} aria-label="Register a Passkey">
            Register a Passkey
          </Button>
          <Button
            variant="outline"
            className="border-line text-foreground hover:bg-hover h-10 w-full rounded-lg bg-transparent"
            onClick={testPasskey}
            aria-label="Test Passkey Authentication"
          >
            Test Passkey Authentication
          </Button>
        </div>
      </div>
    </section>
  );
}
